import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { InventoryDetailsTabProps, InventoryEventHistoryData, TransferHistoryPayload } from './model/inventoryOverview.model';
import Table, { Column } from '../../../Components/Tables/Table';
import { getInventoryEventHistory } from './service/inventoryOverview.service';
import { ApiResponse } from '../../../model/common/apiResponse';
import Loader from '../../../Components/GlobalLoader/Loader';
import { formatDate } from '../../../Utility/Utility';
import { usePagination } from '../../../hooks/usePagination';

export const TransferHistory:React.FC<InventoryDetailsTabProps> = ({
    warehouseId
}) => { 
    const { id } = useParams();
    const [InventoryEventHistoryData, setInventoryEventHistoryData] = useState<ApiResponse<any> | null>(null);
    const [loading, setLoading] = useState(true);
    const { currentPage, handlePageChange, perPage } = usePagination();
    let payload = { ...TransferHistoryPayload };

    const Columns: Column[] = [
        {
            name: "Created On",
            selector: (row: InventoryEventHistoryData) => row?.created_at ? formatDate(row?.created_at) : '-',
        },
        {
            name: "User Name",
            selector: (row: InventoryEventHistoryData) => row?.user_name ? row?.user_name : '-',
        },
        {
            name: "Event Type",
            selector: (row: InventoryEventHistoryData) => row?.event_type ? row?.event_type : '-',
        },
        {
            name: "Warehouse Location",
            selector: (row: InventoryEventHistoryData) => row?.warehouse_location_name ? row?.warehouse_location_name : '-',
        },
        {
            name: "Inventory Status",
            selector: (row: InventoryEventHistoryData) => row?.inventory_status ? row?.inventory_status : '-',
        },
        {
            name: "Lot Number",
            selector: (row: InventoryEventHistoryData) => row?.lot_number ? row?.lot_number : 0,
        },
        {
            name: "Tag Number",
            selector: (row: InventoryEventHistoryData) => row?.tag_number ? row?.tag_number : '-',
        },
        {
            name: "Expiry Date",
            selector: (row: InventoryEventHistoryData) => row?.expiry_date ? formatDate(row?.expiry_date) : '-',
        },
        {
            name: "Serial Number",
            selector: (row: InventoryEventHistoryData) => row?.serial_number ? row?.serial_number : 0,
        },
        {
            name: "FIFO Date",
            selector: (row: InventoryEventHistoryData) => row?.fifo_date ? formatDate(row?.fifo_date) : '-',
        },
        {
            name: "Event Qty",
            selector: (row: InventoryEventHistoryData) => row?.event_qty ? row?.event_qty : 0,
        },
    ];

    useEffect(() => {
        if (id) {
            setLoading(true);
            payload.conditions = [
                ["stock_transfer_event.warehouse_id", "=", warehouseId],
                ["stock_transfer_event.item_id", "=", id]
            ];
            payload.order = [
                {
                    "column": "stock_transfer_event.created_at",
                    "dir": "desc"
                }
            ];
            payload.limit = perPage;
            payload.page = currentPage;
            getInventoryEventHistory(payload).then((response) => {
                setInventoryEventHistoryData(response ?? null);
            }).finally(() => {
                setLoading(false);
            });
        }
    }, [id, currentPage])

    return !loading ? (
        <div className="mb-2 mt-1 bg-white rounded px-4 py-3">
            <Table
                columns={Columns}
                data={InventoryEventHistoryData?.data?.results || []}
                isStripped={true}
                CheckboxStatus={false}
                pagination={{
                    recordsPerPage: perPage,
                    totalRecords: InventoryEventHistoryData?.data?.recordsTotal,
                    currentPage: currentPage,
                    onCurrentPageChange: handlePageChange,
                }}
            />
        </div>
    ) : <Loader />;
}
